import React from "react";
import { TFunction } from "i18next";
import { Button } from "_c/button";
import { useSelector } from "react-redux";
import { Selectors as SearchSelectors } from "@/store/masterSearch/selectors";
import { Selectors as PrefsSelectors } from "@/store/prefs/selectors";
import { useMastersSearchCityPicker } from "@/hooks/useMastersSearchCityPicker";
import PinIcon from "_c/icon/Pin";

type tProps = {
  className?: string;
  t: TFunction;
};
const HeaderMastersSearchCityPicker = (props: tProps) => {
  const searchLocation = useSelector(SearchSelectors.getLocName);
  const searchLocationPref = useSelector(
    PrefsSelectors.getMastersSearchLocation
  )?.label;
  const openPicker = useMastersSearchCityPicker();
  return (
    <div>
      <Button
        small
        withIcon
        onClick={openPicker}
        transparent
        // @ts-ignore
        className={props.className}
      >
        <PinIcon color="currentColor" width="12" />
        <span>
          {searchLocation ||
            searchLocationPref ||
            props.t("common:masters_search_city_picker.empty_choice")}
        </span>
      </Button>
    </div>
  );
};

export default HeaderMastersSearchCityPicker;
